import { Component } from '@angular/core';

@Component({
    selector: 'mlp-ng-spinner',
    templateUrl: './spinner.component.html'
})

export class SpinnerSharedComponent {}
